import { Delete, Edit, Visibility } from '@mui/icons-material';
import { IconButton } from '@mui/material';

const Actions = ({ courseId, onEdit, onView, onDelete }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      {/* View Icon */}
      {/* <IconButton onClick={() => onView(courseId)} title="View">
        <Visibility />
      </IconButton> */}

      {/* Edit Icon */}
      <IconButton
        onClick={() => onEdit(courseId)}
        title="Edit"
        sx={{ color: 'blue' }}
      >
        <Edit />
      </IconButton>

      {/* Delete Icon */}
      <IconButton
        onClick={() => onDelete(courseId)}
        title="Delete"
        sx={{ color: 'red' }}
      >
        <Delete />
      </IconButton>
    </div>
  );
};

export default Actions;
